import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';
import { Grid } from 'react-bootstrap';

import Header from '../../components/Common/Header/Header';
import TalentPool from '../../container/Client/TalentPool/TalentPool';
import ReviewPage from '../../container/Client/Review/Review';
import ProfilePage from '../../components/Client/CandidateProfilePage/ProfilePage';
import PrintPage from '../../components/Client/CandidateProfilePage/PrintCandidateProfile/PrintCandidateProfile';
import ProfileSettings from '../../components/Common/ProfileSettingsPage/ProfileSettingsPage';
import Footer from '../../components/Client/Footer/Footer';
import ClientReport from '../../container/Client/ClientReport/ClientReport';
import './ClientLayout.css';
import ClientInterviewsListContainer from '../../container/Client/ClientInterviews/ClientInterviewsListContainer/ClientInterviewsListContainer';
import ClientInterviewContainer from '../../container/Client/ClientInterviews/ClientInterviewContainer/ClientInterviewContainer';
import ClientInterviewDetailsContainer from '../../container/Client/ClientInterviews/ClientInterviewDetailsContainer/ClientInterviewDetailsContainer';
/**
* @desc Layout for client
* @version 
* @author Lakshmikanth 
*/
class ClientLayout extends React.Component {
  render() {
    return (
      <div className="root">
        <div className="app-container">
          <Header />
          <div className="app-body">
            <Grid>
              <Switch>
                <Route exact path="/" component={TalentPool} />
                <Route exact path="/candidate/:id" component={ProfilePage} />
                <Route exact path="/talentpool/review" component={ReviewPage} />
                <Route exact path="/report" component={ClientReport} />
                <Route exact path="/profile/print/:id" component={PrintPage} />
                <Route exact path="/profile/clientProfile" component={ProfileSettings} />
                <Route exact path="/interviews" component={ClientInterviewsListContainer} />
                <Route exact path="/interviews/interview-view" component={ClientInterviewDetailsContainer} />
                <Route exact path="/interview" component={ClientInterviewContainer} />
              </Switch>
            </Grid>
          </div>
          <div className="simpleLayoutFooter">
            <Footer/>
          </div>
        </div>
      </div>
    );
  }
}

export default ClientLayout;


// WEBPACK FOOTER //
// ./src/hoc/layout/ClientLayout.js